<div class="page-not-found">
  <div class="mt-4 p-5 bg-light rounded unauthorized">
    <h1>404</h1>
    <p>This is not the web page you were looking for.</p>
  </div>
</div>
